/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import Gesture from 'rc-gesture';
import classnames from 'classnames';
import './index.css';
import { any, bool, number } from 'prop-types';

function closest(el, selector) {
  // eslint-disable-next-line
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  // eslint-disable-next-line
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class Swipeout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      swiping: false,
    };
    this.openedLeft = false;
    this.openedRight = false;

    this.content = null;
    this.cover = null;
    this.left = null;
    this.right = null;
    this.btnsLeftWidth = null;
    this.btnsRightWidth = null;
    this.swiping = null;
    this.needShowLeft = null;
    this.needShowRight = null;
  }

  componentDidMount() {
    this.btnsLeftWidth = this.left ? this.left.offsetWidth : 0;
    this.btnsRightWidth = this.right ? this.right.offsetWidth : 0;
    document.body.addEventListener('touchstart', this.onCloseSwipe.bind(this), true);
  }

  componentWillUnmount() {
    document.body.removeEventListener('touchstart', this.onCloseSwipe.bind(this), true);
  }

  onCloseSwipe(ev) {
    // eslint-disable-next-line
    if (!(this.openedLeft || this.openedRight)) {
      return;
    }
    const pNode = closest(ev.target, `.${this.props.prefixCls}-actions`);
    if (!pNode) {
      ev.preventDefault();
      this.close();
    }
  }

  onPanStart(e) {
    const { direction, moveStatus } = e;
    const { x: deltaX } = moveStatus;
    // http://hammerjs.github.io/api/#directions
    const isLeft = direction === 2;
    const isRight = direction === 4;

    if (!isLeft && !isRight) {
      return;
    }
    const { left, right } = this.props;
    // eslint-disable-next-line
    this.needShowRight = isLeft && right && right.length > 0;
    // eslint-disable-next-line
    this.needShowLeft = isRight && left && left.length > 0;
    if (this.left) {
      this.left.style.visibility = this.needShowRight ? 'hidden' : 'visible';
    }
    if (this.right) {
      this.right.style.visibility = this.needShowLeft ? 'hidden' : 'visible';
    }
    if (this.needShowLeft || this.needShowRight) {
      this.swiping = true;
      this.setState({
        swiping: this.swiping,
      });
      this._setStyle(deltaX);
    }
  }

  onPanMove(e) {
    const { moveStatus, srcEvent } = e;
    const { x: deltaX } = moveStatus;
    if (!this.swiping) {
      return;
    }

    // fixed scroll when it's pan and moving.
    if (srcEvent && srcEvent.preventDefault) {
      srcEvent.preventDefault();
    }
    this._setStyle(deltaX);
  }

  onPanEnd(e) {
    if (!this.swiping) {
      return;
    }

    const { moveStatus } = e;
    const { x: deltaX } = moveStatus;

    const needOpenRight = this.needShowRight && Math.abs(deltaX) > this.btnsRightWidth / 2;
    const needOpenLeft = this.needShowLeft && Math.abs(deltaX) > this.btnsLeftWidth / 2;

    if (needOpenRight) {
      this.doOpenRight();
    } else if (needOpenLeft) {
      this.doOpenLeft();
    } else {
      this.close();
    }
    this.swiping = false;
    this.setState({
      swiping: this.swiping,
    });
    this.needShowLeft = false;
    this.needShowRight = false;
  }

  doOpenLeft() {
    this.open(this.btnsLeftWidth, true, false);
  }

  doOpenRight() {
    this.open(-this.btnsRightWidth, true, false);
  }

  // left & right button click
  onBtnClick(ev, btn) {
    const { onPress } = btn;
    if (onPress) {
      onPress(ev);
    }
    if (this.props.autoClose) {
      this.close();
    }
  }

  _getContentEasing(value, limit) {
    // limit content style left when value > actions width
    const delta = Math.abs(value) - Math.abs(limit);
    const isOverflow = delta > 0;
    const factor = limit > 0 ? 1 : -1;
    if (isOverflow) {
      value = limit + Math.pow(delta, 0.85) * factor;
      return Math.abs(value) > Math.abs(limit) ? limit : value;
    }
    return value;
  }

  // set content & actions style
  _setStyle(value) {
    const limit = value > 0 ? this.btnsLeftWidth : -this.btnsRightWidth;
    const contentLeft = this._getContentEasing(value, limit);
    this.content.style.left = `${contentLeft}px`;
    if (this.cover) {
      this.cover.style.display = Math.abs(value) > 0 ? 'block' : 'none';
      this.cover.style.left = `${contentLeft}px`;
    }
  }

  open(value, openedLeft, openedRight) {
    if (!this.openedLeft && !this.openedRight && this.props.onOpen) {
      this.props.onOpen();
    }

    this.openedLeft = openedLeft;
    this.openedRight = openedRight;
    this._setStyle(value);
  }

  close() {
    if ((this.openedLeft || this.openedRight) && this.props.onClose) {
      this.props.onClose();
    }
    this._setStyle(0);
    this.openedLeft = false;
    this.openedRight = false;
  }

  renderButtons(buttons, ref) {
    const { prefixCls } = this.props;

    return (buttons && buttons.length) ? (
      <div
        className={`${prefixCls}-actions ${prefixCls}-actions-${ref}`}
        ref={el => this[ref] = el}
      >
        {
          buttons.map((btn, i) => (
            <div
              key={i}
              className={`${prefixCls}-btn ${btn.hasOwnProperty('className') ? btn.className : ''}`}
              style={btn.style}
              role="button"
              onClick={e => this.onBtnClick(e, btn)}
            >
              {/* <div className={`${prefixCls}-btn-text`} dangerouslySetInnerHTML={{
                __html: btn.text || 'Click'
              }}></div> */}
              <div className={`${prefixCls}-btn-text`}>{btn.text}</div>
            </div>
          ))
        }
      </div>
    ) : null;
  }

  onTouchMove(e) {
    if (this.swiping) {
      e.preventDefault();
    }
  }

  render() {
    const {
      prefixCls, left, right, disabled, children, ...restProps
    } = this.props;

    const {
      autoClose, onOpen, onClose, ...divProps
    } = restProps;

    const cls = classnames(prefixCls, {
      [`${prefixCls}-swiping`]: this.state.swiping,
    });

    const refProps = {
      ref: el => this.content = ReactDOM.findDOMNode(el),
    };

    return ((left && left.length) || (right && right.length)) && !disabled ? (
      <div className={cls} {...divProps}>
        <div className={`${prefixCls}-cover`} ref={el => this.cover = el} />
        { this.renderButtons(left, 'left') }
        { this.renderButtons(right, 'right') }
        <Gesture
          onTouchMove={this.onTouchMove.bind(this)}
          onPanStart={this.onPanStart.bind(this)}
          onPanMove={this.onPanMove.bind(this)}
          onPanEnd={this.onPanEnd.bind(this)}
          onPanCancel={this.onPanEnd.bind(this)}
          onSwipeLeft={this.doOpenRight.bind(this)}
          onSwipeRight={this.doOpenLeft.bind(this)}
          direction="horizontal"
          {...refProps}
        >
          <div className={`${prefixCls}-content`}>{children}</div>
        </Gesture>
      </div>
    ) : (
      <div {...refProps} {...divProps}>{children}</div>
    );
  }
}

Swipeout.propTypes = {
  openedLeft: bool,
  openedRight: bool,
  content: any,
  cover: any,
  left: any,
  right: any,
  btnsLeftWidth: number,
  btnsRightWidth: number,
  swiping: bool,
  needShowLeft: bool,
  needShowRight: bool,
};

Swipeout.defaultProps = {
  prefixCls: 'rc-swipeout',
  autoClose: false,
  disabled: false,
  left: [],
  right: [],
  onOpen() {},
  onClose() {},
};

export default Swipeout;
